// extracted by mini-css-extract-plugin
module.exports = {"worksDescription":"the-works_worksDescription_2Q-zY","worksLink":"the-works_worksLink_32Sd_","password":"the-works_password_1yUtM"};